import React from 'react';
import * as _ from "lodash";

import appIcon from '../img/AppIcon64x64.png'
import {
   GAME_STATUS,
   GAME_STATUS_COMPLETED,
   GAME_TYPE_CODE,
   GAME_TYPE_MIXED,
   GAME_TYPE_TIME,
   TITLE
} from "../constants/Game";

import '..'
import './common_page_elements.css'

export const WizardHeader = (props ) => {

    const { backOutText, backOutAction, index, game } = props;

    // heading:  add short(ened) title to heading of game is present
    const title = game
        ? game[TITLE]
        : null;

    const shortenedTitle = title
            ? title.length < 32
                ? title
                : title.substring(0,30) + "..."
            : null;

    const wizardHeading = shortenedTitle ? shortenedTitle : "Treasure Hunt Wizard";
    const wizardHeadingShort = shortenedTitle ? shortenedTitle : "Hunt Wizard";

    return (
        <div>
            <WizardProgressTable
                progress={index}
                className="pull-right big-side-margins"
                />

            <button
                className="btn accent-link no-side-margins"
                onClick={backOutAction}>
                        {backOutText}
            </button>

            <h3 className="black">
               <span className="full-text">{wizardHeading}</span><span className="short-text">{wizardHeadingShort}</span>
            </h3>

            <p className="wizard-subtitle secondary-text"> {props.subtitle} </p>

            <h2 className="heading-spacing">{props.stepName}</h2>
            <p className="top-margin bottom-margin secondary-text"> {props.stepExplanation} </p>
        </div>
    )
};

export const WizardProgressTable = (props) => {

    const { progress, className } = props;

    const labels = [];
    labels.push("Title & Type");
    labels.push("Location");
    labels.push("Details");
    labels.push("Clues");

    let index = 0;
    const tableItems = labels.map( (label) => {

        const spanClass = (index === progress)
                            ? "wizard-progress-text-current"
                            : (index < progress)
                                    ? "wizard-progress-text-done"
                                    : "wizard-progress-text-future";
        const imgClass = (index === progress)
            ? "checkmark-current"
            : (index < progress)
                ? "checkmark-done"
                : "checkmark-future";
        index++;
        return (
            <tr key={label}>
                <td><img  className={imgClass} alt="check mark" src={appIcon}/>
            </td>
                <td> <span className={spanClass}> {label} </span> </td>
            </tr>
        )
    });

    return (
        <div className={className}>
            <h5 align="center"><u>Progress</u></h5>
            <table>
                <tbody>
                {tableItems}
                </tbody>
            </table>
        </div>
    )
};

// noinspection JSUnusedLocalSymbols
// eslint-disable-next-line
function readableType(gameType) {

    if (gameType === GAME_TYPE_CODE) return "Code to code";
    if (gameType === GAME_TYPE_TIME) return "Time based clues";
    if (gameType === GAME_TYPE_MIXED) return "Mixed clues";
}

export function sortGamesByDate(games) {

    const gamesWithDate = games.map((game) => {
        const dateMillis = _.has(game, 'lastModified')
                                ? game.lastModified.toMillis()
                                : _.has(game, 'created')
                                        ? game.created.toMillis()
                                        : 0;

        return {game: game, date: dateMillis, lastModified: game.lastModified, created: game.created}
    });

    return _.sortBy(gamesWithDate, [ 'date' ]).reverse().map((gameMeta) => {
        return gameMeta.game;
    });
}

export function sortStatsByDate(stats) {

    const statsWithDates = stats.map((entry) => {
        const isComplete = entry[GAME_STATUS] === GAME_STATUS_COMPLETED;
        const date = isComplete ? entry.finishedAt
                            : !!entry.lastUpdated ? entry.lastUpdated : entry.startedAt;

        return {entry: entry, date: date}
    });

    return _.sortBy(statsWithDates, [ 'date' ]).reverse().map((entryMeta) => {
        return entryMeta.entry;
    });
}

export function sortStatsByFarthestClue(stats) {
   return _.sortBy(sortStatsByDate(stats).reverse(), [ 'farthestClue' ]).reverse();
}

export function sortStatsByFastestTime(stats) {
   let statsFarthest = sortStatsByFarthestClue(stats)
   statsFarthest.forEach((entry) => {
      const isComplete = entry.finishTime && entry.startTime;
      let duration = 2000000000;
      if (isComplete) {
         duration = entry.finishTime - entry.startTime;
      }
      entry.duration = duration;
   });
   return _.sortBy(statsFarthest, [ 'duration' ])
}


// a method to render a field with the redux-field object passed in.
export function renderField(reduxField) {

    const { input, autoFocus, name, label, placeholder, type, size, isRow, meta: { touched, error, warning } } = reduxField;

    const className = `right-margin form-group ${touched && error ? 'has-error ' : ''}${isRow ? 'row' : ''}`;
    const labelClass = `${isRow ? 'col-sm-2 col-form-label' : ''}`;

    let innerDivClass = `${isRow ? 'col-sm-10' : ''}`;
    const errorClass = `text-danger ${isRow ? 'push-right-one-fifth' : ''}`;

    return (
       <div>
           <div className={className}>
               {!!label &&
               <label htmlFor={name} className={labelClass}>{label}</label>
               }
               <div className={innerDivClass}>
                   <input
                      autoFocus={autoFocus}
                      className="form-control"
                      type={type}
                      placeholder={placeholder}
                      size={size}
                      {...input}
                   />
               </div>
               {touched &&
               ((error && <span className={errorClass}>{error}</span>) ||
                  (warning && <span className={errorClass}>{warning}</span>))}
           </div>
       </div>
    );
}

// a method to render a text field with an initial, hardcoded value.
export function renderStaticField(reduxField) {
    const { input, name, label, type, isRow } = reduxField;
    const className = `form-group ${isRow ? 'row' : ''}`;
    const labelClass = `${isRow ? 'col-sm-2 col-form-label' : ''}`;
    const innerDivClass = `${isRow ? 'col-sm-10' : ''}`;

    return (
        <div className={className}>
            <label htmlFor={name} className={labelClass}>{label}</label>
            <div className={innerDivClass}>
                <input readOnly
                       className="form-control-plaintext"
                       type={type}
                       {...input}
                />
            </div>
        </div>
    );
}

// a method to render a text area with the redux-field object passed in.
export function renderArea(reduxField) {
    const { input, label, placeholder, type, rows, clueWidth, meta: { touched, error, warning } } = reduxField;
    let className = `form-group ${touched && error ? 'has-error' : ''}`;
    if (clueWidth) className = className + ' right-margin';

    return (
        <div className={className}>

            {!!label && <label>{label}</label>}
            <textarea
                className="form-control"
                type={type}
                placeholder={placeholder}
                rows={rows}
                {...input}
            />
            {touched &&
            ((error && <span className="text-danger">{error}</span>) ||
                (warning && <span>{warning}</span>))}
        </div>
    );
}

export function renderFieldForModal(reduxField) {
    const { input, name, label, type, isRow, meta: { touched, error, warning } } = reduxField;
    const className = `form-group ${touched && error ? 'has-danger ' : ''}${isRow ? 'row' : ''}`;
    const labelClass = `${isRow ? 'col-sm-2 col-form-label' : ''}`;
    const innerDivClass = `${isRow ? 'col-sm-10' : ''}`;
    const errorClass = `text-danger ${isRow ? 'push-right-one-fifth' : ''}`;

    return (
        <div className={className}>
            <label htmlFor={name} className={labelClass}>{label}</label>
            <div className={innerDivClass}>
                <input
                    className="form-control"
                    type={type}
                    {...input}
                />
            </div>
            {touched &&
            ((error && <span className={errorClass}>{error}</span>) ||
                (warning && <span className={errorClass}>{warning}</span>))}
        </div>
    );

}





// WEBPACK FOOTER //
// ./src/components/common_page_elements.js